// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import VideoCapture from './data'

export default function VideoCaptureFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/VideoCapture">
      <VideoCapture {...props}>
        {children}
      </VideoCapture>
    </Flow>
  )
}
